import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { LayoutService } from '../../core/service/layout.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ReviewService } from '../service/review.service';
import { DatePipe } from '@angular/common';
import { ReviewSelectionStatus } from '../model/ReviewSelectionStatus';
import { CaseSplitPipe } from '../../shared/pipe/CaseSplit.pipe';
import { PagerComponent } from '../../shared/pager.component';
import { RegistrantStatus } from '../../accounts/model/RegistrantStatus';

type ReviewBacklogFilterParams = {
  maxDaysLate: number | undefined;
  renewalDate: string | undefined;
  inRemediationThisYear: boolean | undefined;
  reviewSelectionStatus: number | undefined;
  registrationNumber: string | undefined;
  registrationStatus: number | undefined;
};

@Component({
    templateUrl: './reviewBacklog.component.html',
    styleUrls: ['../list.scss', './review.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReviewBacklogComponent implements OnInit, AfterViewInit {


  initialisingCohort = false;
  cohortId: number | undefined;
  renewalDate: string | undefined;
  randomSamplePercent = 2.5;
  ReviewSelectionStatus = ReviewSelectionStatus;
  filterParams;
  activeFilterParams;
  activeFilterParamsInfo: Array<{ key: string; value: string | null | undefined }> = [];
  filterReviewSelectionStatuses: Array<{ key: string; value: string }> = [];
  panel: string | undefined;
  data: any[] = [];
  @ViewChild(PagerComponent) pager!: PagerComponent;
  RegistrationStatus = RegistrantStatus;

  constructor(private router: Router, activatedRoute: ActivatedRoute,
    public layout: LayoutService, public service: ReviewService, private datePipe: DatePipe, private caseSplitPipe: CaseSplitPipe) {

    this.filterParams = this.emptyFilterParams();
    this.filterParams.renewalDate = activatedRoute.snapshot.queryParams['renewalDate'];
    this.activeFilterParams = this.emptyFilterParams();
  }



  ngOnInit() {
    this.filterReviewSelectionStatuses = this.getSelectionStatuses();
  }
  ngAfterViewInit() {
    this.load();
  }

  load() {
    this.pager.load(this.filterParams);
  }

  get loading() {
    if (this.pager) {
      return this.pager.loading;
    } else {
      return true;
    }

  }


  returnToSummary() {

    this.layout.setFullscreen(false);
    this.router.navigate(['./revalidation/review']);

  }

  togglePanel(panel: string) {
    if (this.panel === panel) {
      this.panel = undefined;
    } else {
      this.panel = panel;
    }
  }
  clearAllFilters() {
    this.clearFilterParams();
    this.load();
  }
  clearFilter(filter: keyof ReviewBacklogFilterParams) {
    this.filterParams[filter] = undefined;
    if (this.hasActiveFilterParams) {
      this.load();
    }
  }


  emptyFilterParams(): ReviewBacklogFilterParams {
    return {
      maxDaysLate: undefined,
      renewalDate: undefined,
      inRemediationThisYear: undefined,
      reviewSelectionStatus: undefined,
      registrationNumber: undefined,
      registrationStatus: undefined
    };
  }
  clearFilterParams() {
    this.filterParams = this.emptyFilterParams();
  }

  samplingCreated(renewalDate: string) {
    this.clearFilterParams();
    this.filterParams.renewalDate = renewalDate;
    this.panel = undefined;
    this.load();
  }

  cohortCreated() {
    this.panel = undefined;
  }

  get filterParamsAreActive() {
    if (!this.hasActiveFilterParams) {
      return false;
    }
    for (const key of Object.keys(this.filterParams) as Array<keyof ReviewBacklogFilterParams>) {
      if (this.filterParams[key] !== undefined && this.activeFilterParams[key] === undefined) {
        return false;
      }
      if (this.activeFilterParams[key] !== undefined && this.filterParams[key] === undefined) {
        return false;
      }
      if (this.activeFilterParams[key] !== this.filterParams[key]) {
        return false;
      }
    }
    return true;
  }

  get hasActiveFilterParams() {
    for (const key of Object.keys(this.activeFilterParams) as Array<keyof ReviewBacklogFilterParams>) {
      if (this.activeFilterParams[key] !== undefined && this.activeFilterParams[key] !== null && this.activeFilterParams[key] !== '') {
        return true;
      }
    }
    return false;
  }

  get hasFilterParams() {
    for (const key of Object.keys(this.filterParams) as Array<keyof ReviewBacklogFilterParams>) {
      if (this.filterParams[key] !== undefined && this.filterParams[key] !== null && this.filterParams[key] !== '') {
        return true;
      }
    }
    return false;
  }



  initializeCohort() {
    if (this.renewalDate === undefined) {
      return;
    }
    this.initialisingCohort = true;
    this.service.initializeCohort(this.renewalDate, this.randomSamplePercent).subscribe(result => {
      this.initialisingCohort = false;
      this.cohortId = result.cohortId;
      this.load();
    });
  }

  getSelectionStatuses() {
    const out: Array<{ key: string; value: string }> = [];
    for (const enumMember in ReviewSelectionStatus) {
      if (!isNaN(parseInt(enumMember, 10))) {
        const status = ReviewSelectionStatus[enumMember];
        if (status !== 'Unknown' && typeof status === 'string' && status.toLowerCase().indexOf('exempt') === -1) {
          out.push({
            key: enumMember,
            value: status
          });
        }
      }
    }
    return out;
  }



  onLoad(data: any[]) {
    this.activeFilterParams = Object.assign({}, this.filterParams);

    const formatParamValue = (key: string, value: any) => {
      switch (key) {
        case 'reviewSelectionStatus':
          return this.caseSplitPipe.transform(ReviewSelectionStatus[value]!);
        case 'registrationStatus':
          return this.RegistrationStatus[value];
        case 'renewalDate':
          return 'Renewal date: ' + this.datePipe.transform(value, 'dd/MM/yyyy');
        case 'inRemediationThisYear':
          return value ? 'In remediation' : 'Not in remediation';
        case 'maxDaysLate':
          return 'Up to ' + value + ' days late';
        default:
          return this.caseSplitPipe.transform(key) + ': ' + value;
      }
    };

    this.activeFilterParamsInfo = (Object.keys(this.activeFilterParams) as Array<keyof ReviewBacklogFilterParams>).map(key => {
      if (this.activeFilterParams[key] !== undefined) {
        return { key, value: formatParamValue(key, this.activeFilterParams[key]) };
      }
      return false;
    }).filter(v => !!v);
    if (data.length) {
      this.panel = undefined;
    }
    this.data = data;

  }




}
